import { createSlice } from '@reduxjs/toolkit'
import { PriceType, PriceTypeShow } from '../../Constants/TableConfiguration'
import { Language_IT, listingsAllValue } from '../../Constants/Configuration'
import { renderTranslation } from '../../Helpers/GenericHelpers'
import { TranslationKeys } from '../../Constants/TranslationKeys'
import { TypeOfChannel } from 'Slices/Omnichannel/DiscountSlice'
import { PricetoSave } from 'Helpers/PricesHelper'

const listingAllValue = {
  value: listingsAllValue,
  label: renderTranslation(Language_IT, TranslationKeys.priceSectionDropdownListingAllValue),
}

export const priceSlice = createSlice({
  name: 'price',
  initialState: {
    priceListingFilter: [listingAllValue],
    priceTypeFilter: [PriceType.sell, PriceType.purchase],
    priceTypeShow: PriceTypeShow.omni,
    priceFilterDateRange: [null, null],
    channelType: TypeOfChannel.Marketplace,
    priceChanged: [] as PricetoSave[],
  },
  reducers: {
    setPriceChanged: (state, action) => {
      const existingIndex = state.priceChanged.findIndex(
        item =>
          item.pricelist === action.payload.pricelist &&
          item.PriceType === action.payload.PriceType &&
          item.SizeId === action.payload.SizeId,
      )
      if (existingIndex !== -1) state.priceChanged.splice(existingIndex, 1)
      state.priceChanged.push(action.payload)
    },
    resetPriceChanged: state => {
      state.priceChanged = []
    },
    setPriceListingFilter: (state, action) => {
      state.priceListingFilter = action.payload
    },
    setPriceTypeFilter: (state, action) => {
      if (state.priceTypeFilter.indexOf(action.payload) === -1) {
        state.priceTypeFilter.push(action.payload)
      } else {
        if (state.priceTypeFilter.length > 1) {
          state.priceTypeFilter = state.priceTypeFilter.filter(x => x !== action.payload)
        }
      }
    },
    setPriceTypeShow: (state, action) => {
      state.priceTypeShow = action.payload
    },

    setPriceFilterDateRange: (state, action) => {
      state.priceFilterDateRange = action.payload
    },
    setChannelType: (state, action) => {
      state.channelType = action.payload
    },
    resetPriceTypeFilter: state => {
      state.priceTypeFilter = [PriceType.sell, PriceType.purchase]
    },
  },
  extraReducers: builder => {},
})

export const {
  setPriceChanged,
  resetPriceChanged,
  setPriceListingFilter,
  setPriceTypeFilter,
  setPriceTypeShow,
  setPriceFilterDateRange,
  setChannelType,
  resetPriceTypeFilter,
} = priceSlice.actions

export default priceSlice.reducer
